import { channelManagementDemoData } from 'open-modules/zdf/component/channels/__demos__/channel-demo.data';
import { CLICK, componentWithVariants, demoFile, HOVER, INPUT, POPUP, story, variant } from 'system/demo';
import type { TestState } from 'util/datastore';

import { ChannelManagement } from '../channel-management';

demoFile('open-modules/zdf/component/channels/channel-management', {
    designUrl: 'https://www.figma.com/design/ywh2aOQyFKATNi0oJMAePn/Moderation-Dashboard---Testing?node-id=7824-99214&t=57jh1Wk6mNWa6szW-0',
});

function ChannelManagementDemo() {
    return <ChannelManagement />;
}

const demoData = channelManagementDemoData;

const channelManagementTestState: TestState = {
    personaKey: 'a',
    serverCall: demoData.serverCall,
    modulePublic: demoData.modulePublic,
};

componentWithVariants('ChannelManagement', ChannelManagementDemo, {}, [
    variant(
        'Owner',
        {
            state: {
                ...channelManagementTestState,
                roles: ['Owner'],
                // HACK?: Clone channel members object to avoid permanently altering it
                sessionData: { channelMembers: JSON.parse(JSON.stringify(demoData.channelMembers)) },
            },
        },
        [
            story('Add default channel', [
                CLICK('Add channel'),
                POPUP(INPUT('channel-name', 'ZDF')),
                POPUP(INPUT('image-url', 'https://psi.zdf.de/faces/robo.jpeg')),
                POPUP(HOVER('default-channel-infotag')),
                POPUP(CLICK('default-channel-toggle')),
                POPUP(CLICK('Save')),
            ]),
            story('Add channel', [
                CLICK('Add channel'),
                POPUP(INPUT('channel-name', 'ZDF')),
                POPUP(INPUT('image-url', 'https://psi.zdf.de/faces/robo.jpeg')),
                POPUP(CLICK('Save')),
            ]),
            story('Add channel with members', [
                CLICK('Add channel'),
                POPUP(INPUT('channel-name', 'ZDF')),
                POPUP(INPUT('image-url', 'https://psi.zdf.de/faces/robo.jpeg')),
                POPUP(CLICK('add-members-pressable')),
                POPUP(CLICK('a@b.com')),
                POPUP(CLICK('c@d.com')),
                POPUP(CLICK('Add')),
                POPUP(CLICK('Save')),
            ]),
            story('Edit channel', [
                CLICK('edit-channel1'),
                POPUP(INPUT('channel-name', 'ZDF')),
                POPUP(INPUT('image-url', 'https://psi.zdf.de/faces/face1.jpeg')),
                POPUP(CLICK('default-channel-toggle')),
                POPUP(CLICK('Save')),
            ]),
            story('Edit members', [
                CLICK('edit-channel0'),
                POPUP(CLICK('add-members-pressable')),
                POPUP(CLICK('test@test.com')),
                POPUP(CLICK('a@b.com')), // Remove member by unchecking them
                POPUP(CLICK('Add')),
                POPUP(CLICK('Save')),
            ]),
            story('Remove members', [
                CLICK('edit-channel2'),
                POPUP(CLICK('remove-c@d.com')),
                POPUP(CLICK('remove-test@test.com')),
                POPUP(CLICK('Save')),
            ]),
            story('Delete channel', [CLICK('delete-channel1'), POPUP(CLICK('Delete'))]),
            story('Hover delete disabled', [HOVER('delete-tooltip-channel2')]),
        ],
    ),
    variant(
        'Super-Moderator',
        {
            state: {
                ...channelManagementTestState,
                roles: ['Super-Moderator'],
                // HACK?: Clone channel members object to avoid permanently altering it
                sessionData: { channelMembers: JSON.parse(JSON.stringify(demoData.channelMembers)) },
            },
        },
        [
            story('Edit members', [
                CLICK('edit-channel0'),
                POPUP(CLICK('add-members-pressable')),
                POPUP(CLICK('test@test.com')),
                POPUP(CLICK('a@b.com')), // Remove member by unchecking them
                POPUP(CLICK('Add')),
                POPUP(CLICK('Save')),
            ]),
            // This story fails if it uses the same channel member object as the other "Remove members" story
            story('Remove members', [
                CLICK('edit-channel2'),
                POPUP(CLICK('remove-c@d.com')),
                POPUP(CLICK('remove-test@test.com')),
                POPUP(CLICK('Save')),
            ]),
        ],
    ),
    variant('Moderator', {
        state: { ...channelManagementTestState, roles: ['Moderator'] },
    }),
    variant('No admin', {
        state: { ...channelManagementTestState, roles: [''] },
    }),
]);
